import React from "react";
import "./styles.css";

const QuestionNotAnswered = ({ width, height, customCss = {}, children }) => {
  return (
    <div
      className="Not_answered"
      style={{
        ...(width && { width }),
        ...(height && { height }),
        ...customCss,
      }}
    >
      {children}
    </div>
  );
};

export default QuestionNotAnswered;
